import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const SmsIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M4 6.677C4 5.752 4.752 5 5.677 5H17.323C18.248 5 19 5.752 19 6.676V12.832C19 13.757 18.248 14.509 17.323 14.509H8.517L4 18.194V6.677ZM5.947 6.383C5.76276 6.38326 5.58613 6.45657 5.45585 6.58685C5.32557 6.71713 5.25226 6.89376 5.252 7.078V15.402C6.887 14.073 7.763 13.351 7.879 13.236C8.054 13.063 8.226 12.967 8.559 12.967H16.958C17.1422 12.9667 17.3189 12.8934 17.4491 12.7631C17.5794 12.6329 17.6527 12.4562 17.653 12.272V7.077C17.6527 6.89276 17.5794 6.71613 17.4491 6.58585C17.3189 6.45557 17.1422 6.38226 16.958 6.382L5.947 6.383Z'
                fill='currentColor'
            />
        </>
    ),
})

SmsIcon.displayName = 'SmsIcon'
